import React, { type FC } from "react";

import { StateComponent } from "./StateComponent";
import { StateRelationArrowIcon } from "./StateRelationArrowIcon";
import type { SimpleRelation } from "./state-relation-utils";

export interface StateRelationProps {
	relation: SimpleRelation;
}

export const StateRelation: FC<StateRelationProps> = ({ relation }) => (
	<div className="flex items-center" data-testid="state-relation">
		<StateComponent component={relation.source} data-testid="state-relation-source-state" displayName={false} />

		<StateRelationArrowIcon
			className="mx-[5px]"
			data-testid="state-relation-icon"
			dependencyDirection={relation.dependencyDirection}
			iconSize="small"
			type={relation._type}
		/>

		<StateComponent component={relation.target} data-testid="state-relation-target-state" displayName={false} />
	</div>
);
